export const saveContent = (fileName: string, url: string, openInNewTab = false) => {
  const link = document.createElement('a');
  link.download = fileName;
  link.href = url;
  if (openInNewTab) link.target = '_blank';
  link.click();
};

export const saveBinaryContent = (fileName: string, binary: Blob) => {
  const objectUrl = URL.createObjectURL(binary);
  saveContent(fileName, objectUrl);
  URL.revokeObjectURL(objectUrl);
};

export const saveTextContent = (fileName: string, text: string) => {
  const pom = document.createElement('a');
  pom.setAttribute('href', `data:text/plain;charset=utf-8,${encodeURIComponent(text)}`);
  pom.setAttribute('download', fileName);
  const event = new MouseEvent('click', { bubbles: true, cancelable: true });
  pom.dispatchEvent(event);
};
